import { IAlert } from '../../types/entities/IAlert';
import { ServerNotification } from '../../types/serverNotifications/serverNotificationTypes';
import { getNotificationConfig } from '../../utils/serverNotifications/serverNotificationsUtils';

type ServerNotificationAlert = Partial<
    Pick<
        IAlert,
        | 'Id'
        | 'IdAlertType'
        | 'Description'
        | 'AutoResolveDate'
        | 'Resolved'
        | 'EntityId'
        | 'EntityName'
        | 'IdSystemUser'
    >
> & {
    AlertType?: Partial<Pick<IAlert['AlertType'], 'Name' | 'Key'>>;
    SystemUser?: Partial<Pick<IAlert['SystemUser'], 'Name'>>;
};

/**
 * Maps projected backend alerts to header notifications.
 * @param data Alerts containing the notification fields.
 * @returns Notifications ready for display.
 */
export const adaptServerNotifications = (
    data: ServerNotificationAlert[]
): ServerNotification[] => {
    return data.map(alert => {
        const alertTypeKey = alert?.AlertType?.Key || '';
        const { typeIcon, statusIcon, statusColor, statusBackgroundColor } =
            getNotificationConfig(alertTypeKey);

        return {
            id: alert.Id || '',
            idAlertType: alert.IdAlertType || 0,
            alertType: alert?.AlertType?.Name || '',
            alertTypeKey,
            description: alert.Description || '',
            autoResolvedDate: alert.AutoResolveDate || null,
            resolved: alert.Resolved || false,
            idEntity: alert.EntityId || 0,
            entityName: alert.EntityName || '',
            idSystemUser: alert.IdSystemUser || 0,
            systemUser: alert?.SystemUser?.Name || '',
            alertTypeIcon: typeIcon,
            statusIcon,
            statusColor,
            statusBackgroundColor,
        };
    });
};
